import React from "react"

type ToggleSearchProps = {
  onClick: () => void
  buttonDisabled: boolean
  entityName: string
}

export const ToggleSearch = ({
  onClick,
  buttonDisabled,
  entityName,
}: ToggleSearchProps) => {
  return (
    <button
      data-test="toggle-search__button"
      onClick={onClick}
      aria-controls={`${entityName}-search`}
      aria-label="Show search box"
      className="flex items-center justify-center bg-black hover:bg-white focus:bg-white text-white hover:text-black focus:text-black border border-black rounded-md transition-colors duration-100 px-12 py-8 focus:outline-none focus-visible:outline-dark"
      id={`${entityName}-search-toggle`}
      disabled={buttonDisabled}
    >
      <svg
        aria-hidden="true"
        aria-labelledby={`${entityName}-search-icon`}
        className="w-20 h-20"
        focusable="false"
        height="16"
        role="img"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title id={`${entityName}-search-icon`}>Show search box</title>
        <path
          clipRule="evenodd"
          d="m11.4351 10.0629h-.7227l-.2561-.247c.8965-1.04289 1.4362-2.3968 1.4362-3.86964 0-3.28417-2.66208-5.94626-5.94624-5.94626-3.28417 0-5.94626 2.66209-5.94626 5.94626 0 3.28416 2.66209 5.94624 5.94626 5.94624 1.47284 0 2.82675-.5397 3.86964-1.4362l.247.2561v.7227l4.574 4.5649 1.3631-1.3631zm-5.48884 0c-2.27788 0-4.11664-1.83877-4.11664-4.11664 0-2.27788 1.83876-4.11664 4.11664-4.11664 2.27787 0 4.11664 1.83876 4.11664 4.11664 0 2.27787-1.83877 4.11664-4.11664 4.11664z"
          fillRule="evenodd"
        ></path>
      </svg>
      <span className="sr-only">Show search box</span>
    </button>
  )
}
